import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalFooter,
  Button,
  Row,
  FormGroup,
  Input,
  Label,
  ModalBody,
  Card,
  CardBody,
} from "reactstrap";
import Creatable from "../../../components/common/CreatableSelect";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AddCommaNumber, CleanPrice } from "../../../helpers/Utils";
import PriceInput from "../../../components/common/PriceInput";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import SizeAndTopping from "./SizeAndTopping";
import { v4 as uuidv4 } from "uuid";
import IceAndSugar from "./IceAndSugar";
import { SetIceOrSugar } from "../../../helpers/Product";
import { NotificationManager } from "../../../components/common/react-notifications";
import * as variantHandlers from "../../../views/app/pages/product/productVariantHandlers";

class ProductVariantConfigModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // F&B Data
      sizeTitle: "Size",
      toppingTitle: "Topping",
      iceTitle: "Lượng đá",
      sugarTitle: "Độ ngọt",
      sizes: [],
      toppings: [],
      ice: [],
      sugar: [],
      // Retail Data
      sizeOptions: [],
      colorOptions: [],
      materialOptions: [],
      // Dynamic Titles for Retail
      colorTitle: "Màu sắc",
      materialTitle: "Chất liệu",
      // Variant Generation Data
      generatedVariants: [],
      masterVariantSettings: {
        price: "",
        price_wholesale: "",
        cost_price: "", // Added Cost Price
        promo_price: "",
        quantity: "", // Add quantity to master settings
        date_start: null,
        date_end: null,
      },
      baseSku: "",
    };
    this.nextSizeId = 1;
    this.nextToppingId = 1;
  }

  componentDidMount() {
    if (this.props.data) {
      this.parseData(this.props.data);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data && this.props.data) {
      this.parseData(this.props.data);
    }

    // Listen for options updates (e.g. valid loaded from data_all)
    if (prevProps.allSizeOptions !== this.props.allSizeOptions) {
      this.setState((prev) => ({
        sizeOptions:
          prev.sizeOptions.length === 0
            ? this.props.allSizeOptions || []
            : prev.sizeOptions,
      }));
    }
    if (prevProps.allColorOptions !== this.props.allColorOptions) {
      this.setState((prev) => ({
        colorOptions:
          prev.colorOptions.length === 0
            ? this.props.allColorOptions || []
            : prev.colorOptions,
      }));
    }
    if (prevProps.allMaterialOptions !== this.props.allMaterialOptions) {
      this.setState((prev) => ({
        materialOptions:
          prev.materialOptions.length === 0
            ? this.props.allMaterialOptions || []
            : prev.materialOptions,
      }));
    }
  }

  parseData = (data) => {
    // Helper to normalize options for react-select (must have label & value)
    const normalizeOptions = (options) => {
      if (!Array.isArray(options)) return [];
      return options.map(variantHandlers.normalizeVariantOption).filter(Boolean);
    };
    const variants = (data.variants || []).map(variantHandlers.normalizeVariant);
    const ownOptions = (field) => {
      const selected = normalizeOptions(data[field]);
      return selected.length ? selected : variantHandlers.extractAllUniqueOptions(variants.map((v) => v.attributes), field);
    };

    const { business_type } = this.props;
    let defaultSizeTitle = "Size";
    let defaultColorTitle = "Màu sắc";
    let defaultMaterialTitle = "Chất liệu";

    let initialSizes = data.sizes || [];

    // Pre-fill S, M, L for Cafe if sizes is empty
    if (business_type === "cafe" && initialSizes.length === 0) {
      initialSizes = [
        { id: 1, name: "Size S", value: 0 },
        { id: 2, name: "Size M", value: 0 },
        { id: 3, name: "Size L", value: 0 },
      ];
    } else if (business_type === "restaurant" && initialSizes.length === 0) {
      initialSizes = [
        { id: 1, name: "Phần vừa", value: 0 },
        { id: 2, name: "Phần lớn", value: 0 },
      ];
    } else if (business_type === "retail" || business_type === "grocery") {
      defaultSizeTitle = "Quy cách (Lon, thùng...)";
      defaultColorTitle = "Dung tích / Trọng lượng (330ml, 500g...)";
      defaultMaterialTitle = "Hương vị (Vị dâu, chanh...)";
    } else if (business_type === "pharmacy") {
      defaultSizeTitle = "Quy cách đóng gói (Vỉ, Hộp...)";
      defaultColorTitle = "Hàm lượng / Nồng độ (500mg, 10ml...)";
      defaultMaterialTitle = "Hoạt chất chính (Paracetamol...)";
    } else if (business_type === "electronics") {
      defaultSizeTitle = "Dung lượng / Kích thước (128GB, 6.1 inch...)";
      defaultColorTitle = "Màu sắc (Đen, Trắng...)";
      defaultMaterialTitle = "Thông số kỹ thuật";
    } else if (business_type === "spa" || business_type === "salon") {
      defaultSizeTitle = "Dung tích / Kích cỡ (50ml, Lớn...)";
      defaultColorTitle = "Màu sắc / Mùi hương";
      defaultMaterialTitle = "Loại liệu trình / Dịch vụ";
    } else if (business_type === "cosmetics" || business_type === "beauty") {
      defaultSizeTitle = "Dung tích (330ml, 500ml...)";
      defaultColorTitle = "Màu sắc/Tone";
    }

    let initialIce = data.ice || [];
    let initialSugar = data.sugar || [];

    // Pre-fill Ice/Sugar for Cafe ONLY
    if (
      business_type === "cafe" &&
      initialIce.length === 0 &&
      initialSugar.length === 0
    ) {
      const allOptions = SetIceOrSugar().map((o) => o.value);
      initialIce = allOptions;
      initialSugar = allOptions;
    }

    this.setState({
      sizeTitle: data.sizeTitle || defaultSizeTitle,
      toppingTitle: data.toppingTitle || "Topping",
      iceTitle: data.iceTitle || "Lượng đá",
      sugarTitle: data.sugarTitle || "Độ ngọt",
      sizes: initialSizes,
      toppings: data.toppings || [],
      ice: initialIce,
      sugar: initialSugar,
      // Load Dynamic Titles
      colorTitle: data.colorTitle || defaultColorTitle,
      materialTitle: data.materialTitle || defaultMaterialTitle,
      sizeOptions:
        ownOptions("size").length > 0
          ? ownOptions("size")
          : this.props.allSizeOptions || [],
      colorOptions:
        ownOptions("color").length > 0
          ? ownOptions("color")
          : this.props.allColorOptions || [],
      materialOptions:
        ownOptions("material").length > 0
          ? ownOptions("material")
          : this.props.allMaterialOptions || [],
      generatedVariants: variants,
      basePrice: data.price ?? "",
      baseSku: data.sku || "",
    });

    // For Retail: Auto-add baseUnit to sizeOptions if not already present
    // Modified: Logic disabled ONLY for 'fashion' based on user request.
    // It remains active for 'retail' and 'cosmetics'.
    if (
      (this.props.business_type === "retail" ||
        this.props.business_type === "cosmetics") &&
      this.props.baseUnit
    ) {
      const baseUnitValue = this.props.baseUnit.trim();
      if (baseUnitValue) {
        this.setState((prev) => {
          const existingOption = prev.sizeOptions.find(
            (opt) =>
              opt.value?.toLowerCase() === baseUnitValue.toLowerCase() ||
              opt.label?.toLowerCase() === baseUnitValue.toLowerCase(),
          );
          if (!existingOption) {
            return {
              sizeOptions: [
                { label: baseUnitValue, value: baseUnitValue },
                ...prev.sizeOptions,
              ],
            };
          }
          return {};
        });
      }
    }
    // Set next IDs
    if (data.sizes && data.sizes.length > 0) {
      this.nextSizeId = Math.max(...data.sizes.map((s) => s.id || 0)) + 1;
    }
    if (data.toppings && data.toppings.length > 0) {
      this.nextToppingId = Math.max(...data.toppings.map((t) => t.id || 0)) + 1;
    }
  };

  // Handler chung cho title
  handleTitleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  // --- Size & Topping Handlers (giống AddProductTabs) ---
  onAddSizeAndTopping = (type) => {
    if (type === "size") {
      this.setState((prev) => ({
        sizes: [...prev.sizes, { id: this.nextSizeId++, name: "", value: 0 }],
      }));
    } else {
      this.setState((prev) => ({
        toppings: [
          ...prev.toppings,
          { id: this.nextToppingId++, name: "", value: 0 },
        ],
      }));
    }
  };

  onChangeSizeAndTopping = (value, type, id, field) => {
    const key = type === "size" ? "sizes" : "toppings";
    this.setState((prev) => ({
      [key]: prev[key].map((item) =>
        item.id === id
          ? {
              ...item,
              [field]: field === "value" ? value.replace(/,/g, "") : value,
            }
          : item,
      ),
    }));
  };

  onRemoveSizeAndTopping = (type, id) => {
    const key = type === "size" ? "sizes" : "toppings";
    this.setState((prev) => ({
      [key]: prev[key].filter((item) => item.id !== id),
    }));
  };

  // --- Ice & Sugar Handler ---
  onChangeIceAndSugar = ({ name, value }) => {
    this.setState((prev) => {
      const current = prev[name] || [];
      if (current.includes(value)) {
        return { [name]: current.filter((x) => x !== value) };
      }
      return { [name]: [...current, value] };
    });
  };

  // --- Variant Generation Logic ---
  handleGenerateVariants = () => {
    const {
      sizeOptions,
      colorOptions,
      materialOptions,
      generatedVariants,
      basePrice,
    } = this.state;

    const mergedVariants = variantHandlers.generateVariants({
      existingVariants: generatedVariants,
      price: basePrice,
      priceWholesale: this.props.basePriceWholesale,
      costPrice: this.props.baseCostPrice,
      size: sizeOptions.length ? sizeOptions : [{ label: "", value: "no-size" }],
      color: colorOptions,
      material: materialOptions,
    }).map((variant) => {
      const normalized = variantHandlers.normalizeVariant(variant);
      const name = [normalized.size.label, normalized.color.label, normalized.material.label]
        .filter((label) => label && label.trim()).join(" - ");
      return { ...normalized, name: name || variant.name };
    });

    // 4. Ensure Base SKU exists
    let currentBaseSku = this.state.baseSku;
    if (!currentBaseSku) {
      currentBaseSku = `SP-${uuidv4().substring(0, 8).toUpperCase()}`;
      this.setState({ baseSku: currentBaseSku });
    }

    const finalVariants = variantHandlers.allocateVariantSkus(mergedVariants, currentBaseSku);

    this.setState({ generatedVariants: finalVariants });
  };

  handleMasterSettingsChange = (value, field) => {
    this.setState((prev) => ({
      masterVariantSettings: {
        ...prev.masterVariantSettings,
        [field]: value,
      },
    }));
  };

  applyMasterSettingsToAll = () => {
    const { masterVariantSettings, generatedVariants } = this.state;
    const newVariants = generatedVariants.map((v) => ({
      ...v,
      price: variantHandlers.hasInventoryValue(masterVariantSettings.price)
        ? CleanPrice(masterVariantSettings.price)
        : v.price,
      price_wholesale: variantHandlers.hasInventoryValue(masterVariantSettings.price_wholesale)
        ? CleanPrice(masterVariantSettings.price_wholesale)
        : v.price_wholesale,
      promo_price: variantHandlers.hasInventoryValue(masterVariantSettings.promo_price)
        ? CleanPrice(masterVariantSettings.promo_price)
        : v.promo_price,
      cost_price: variantHandlers.hasInventoryValue(masterVariantSettings.cost_price)
        ? CleanPrice(masterVariantSettings.cost_price)
        : v.cost_price,
      quantity: variantHandlers.hasInventoryValue(masterVariantSettings.quantity)
        ? CleanPrice(masterVariantSettings.quantity)
        : v.quantity,
      date_start: masterVariantSettings.date_start || v.date_start,
      date_end: masterVariantSettings.date_end || v.date_end,
    }));
    this.setState({ generatedVariants: newVariants });
  };

  onChangeVariant = (id, field, value) => {
    const { baseUnit, basePrice, baseCostPrice } = this.props;
    const cleanValue =
      field.includes("price") ||
      field === "quantity" ||
      field === "exchange_value"
        ? CleanPrice(value)
        : value;

    this.setState((prev) => {
      // Find the variant being changed
      const targetVariant = prev.generatedVariants.find((v) => v.id === id);
      if (!targetVariant) return prev;

      // Check if this is a derived variant (not base unit)
      const variantSizeValue =
        targetVariant.size?.value || targetVariant.size?.label || "";
      const isBaseUnitVariant =
        baseUnit &&
        variantSizeValue &&
        variantSizeValue.toLowerCase() === baseUnit.toLowerCase();

      // If changing exchange_value on a derived variant, auto-calculate prices
      if (field === "exchange_value" && !isBaseUnitVariant) {
        const exchangeValue = parseFloat(cleanValue) || 1;

        // Get base prices from props (main form) - this is the source of truth
        // baseCostPrice comes from stock_cost_price in main form
        // basePrice comes from price in main form
        let basePriceNum = parseFloat(basePrice) || 0;
        let baseCostNum = parseFloat(baseCostPrice) || 0;

        // If basePrice is 0, try to get from base unit variant's price
        if (!basePriceNum) {
          const baseVariant = prev.generatedVariants.find((v) => {
            const sizeVal = v.size?.value || v.size?.label || "";
            return sizeVal.toLowerCase() === (baseUnit || "").toLowerCase();
          });
          if (baseVariant && baseVariant.price) {
            basePriceNum = parseFloat(baseVariant.price) || 0;
          }
        }
        // Note: baseCostNum always from props because base unit variant doesn't have cost input

        const calculatedPrice = basePriceNum * exchangeValue;
        const calculatedCost = baseCostNum * exchangeValue;

        return {
          generatedVariants: prev.generatedVariants.map((v) =>
            v.id === id
              ? {
                  ...v,
                  exchange_value: cleanValue,
                  price: calculatedPrice.toString(),
                  cost_price: calculatedCost.toString(),
                }
              : v,
          ),
        };
      }

      // Normal field update
      return {
        generatedVariants: prev.generatedVariants.map((v) =>
          v.id === id
            ? {
                ...v,
                [field]: cleanValue,
              }
            : v,
        ),
      };
    });
  };

  handleTitleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleDeleteVariant = (id) => {
    this.setState((prev) => ({
      generatedVariants: prev.generatedVariants.filter((v) => v.id !== id),
    }));
  };

  // --- Creatable Handler for Tags (Fashion/Retail/Cosmetics) ---
  handleCreatableChange = (newValue, actionMeta) => {
    const { name } = actionMeta;
    // Normalize new value to ensure label/value exist
    const normalizedValue = (newValue || []).map((item) => {
      if (typeof item === "string") {
        return { label: item, value: item };
      }
      if (item.__isNew__) {
        return { ...item, label: item.value, value: item.value };
      }
      return item;
    });
    this.setState({ [name]: normalizedValue });
  };

  handleSave = () => {
    const {
      sizeTitle,
      toppingTitle,
      iceTitle,
      sugarTitle,
      sizes,
      toppings,
      ice,
      sugar,
      sizeOptions,
      colorOptions,
      materialOptions,
      generatedVariants,
    } = this.state;
    const { business_type } = this.props;

    // Validation: If attributes exist but no variants generated (Retail/Fashion)
    const isRetailMode =
      business_type !== "cafe" && business_type !== "restaurant";
    const hasAttributes =
      (sizeOptions && sizeOptions.length > 0) ||
      (colorOptions && colorOptions.length > 0) ||
      (materialOptions && materialOptions.length > 0);

    if (
      isRetailMode &&
      hasAttributes &&
      (!generatedVariants || generatedVariants.length === 0)
    ) {
      NotificationManager.warning(
        "Bạn đã thêm thuộc tính nhưng chưa tạo biến thể. Vui lòng nhấn 'Tạo biến thể tự động' để tiếp tục.",
        "Cảnh báo",
        5000,
        null,
        null,
        "",
      );
      return;
    }

    // Validation: Strict check for Price, Quantity, Cost Price in generated variants
    if (
      business_type === "retail" ||
      business_type === "fashion" ||
      business_type === "cosmetics" ||
      isRetailMode
    ) {
      if (generatedVariants && generatedVariants.length > 0) {
        const invalidVariants = generatedVariants.filter((v) => {
          // Check if any required field is missing
          return [v.price, v.quantity, v.cost_price].some((value) => !variantHandlers.hasInventoryValue(value));
        });

        if (invalidVariants.length > 0) {
          NotificationManager.warning(
            "Vui lòng nhập đầy đủ Giá bán, Giá vốn và Số lượng cho tất cả các biến thể.",
            "Cảnh báo",
            5000,
            null,
            null,
            "",
          );
          return;
        }
      }
    }

    // Filter empty items and ensure price exists for sizes/toppings
    // User requested: "check if there is price then push"
    const cleanSizes = sizes.filter(
      (s) => s.name && s.name.trim() && s.value && parseFloat(s.value) > 0,
    );

    const cleanToppings = toppings.filter((t) => t.name && t.name.trim());

    this.props.onSave({
      sizeTitle,
      toppingTitle,
      iceTitle,
      sugarTitle,
      sizes: cleanSizes,
      toppings: cleanToppings,
      ice,
      sugar,
      size: sizeOptions,
      color: colorOptions,
      material: materialOptions,
      // Pass back dynamic titles
      colorTitle: this.state.colorTitle,
      materialTitle: this.state.materialTitle,
      variants: this.state.generatedVariants,
      sku: this.state.baseSku,
    });
    this.props.toggle();
  };

  render() {
    const { isOpen, toggle, business_type } = this.props;
    const {
      sizeTitle,
      toppingTitle,
      iceTitle,
      sugarTitle,
      sizes,
      toppings,
      ice,
      sugar,
      generatedVariants,
      masterVariantSettings,
    } = this.state;
    const isFnB = business_type === "cafe" || business_type === "restaurant";
    const isCafe = business_type === "cafe";
    const isRetail =
      business_type === "retail" ||
      business_type === "grocery" ||
      business_type === "pharmacy" ||
      business_type === "electronics" ||
      business_type === "spa" ||
      business_type === "salon";
    const isCosmetics =
      business_type === "cosmetics" || business_type === "beauty";

    // console.log("generatedVariants", generatedVariants);
    // console.log("masterVariantSettings", masterVariantSettings);

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
        <ModalHeader toggle={toggle}>Biến thể & Giá</ModalHeader>
        <ModalBody>
          {isFnB ? (
            <Row>
              {/* Size */}
              <Colxx md={6}>
                <FormGroup className="mb-4">
                  <div className="d-flex mb-2">
                    <Input
                      className="custom-input-underline w-50 pad-2px"
                      type="text"
                      name="sizeTitle"
                      value={sizeTitle}
                      placeholder="Size"
                      onChange={this.handleTitleChange}
                    />
                  </div>
                  <SizeAndTopping
                    onAdd={() => this.onAddSizeAndTopping("size")}
                    onChange={this.onChangeSizeAndTopping}
                    onRemove={this.onRemoveSizeAndTopping}
                    name="size"
                    values={sizes}
                    disabled={false}
                  />
                </FormGroup>
              </Colxx>

              {/* Topping */}
              <Colxx md={6}>
                <FormGroup className="mb-4">
                  <div className="d-flex mb-2">
                    <Input
                      className="custom-input-underline w-50 pad-2px"
                      type="text"
                      name="toppingTitle"
                      value={toppingTitle}
                      placeholder="Topping"
                      onChange={this.handleTitleChange}
                    />
                  </div>
                  <SizeAndTopping
                    onAdd={() => this.onAddSizeAndTopping("topping")}
                    onChange={this.onChangeSizeAndTopping}
                    onRemove={this.onRemoveSizeAndTopping}
                    name="topping"
                    values={toppings}
                    disabled={false}
                  />
                </FormGroup>
              </Colxx>

              {/* Ice & Sugar - chỉ cho cafe */}
              <Colxx md={12}>
                <hr />
                <Row>
                  <Colxx md={6}>
                    <FormGroup className="mb-4">
                      <div className="d-flex mb-2">
                        <Input
                          className="custom-input-underline w-50 pad-2px"
                          type="text"
                          name="iceTitle"
                          value={iceTitle}
                          placeholder="Lượng đá"
                          onChange={this.handleTitleChange}
                        />
                      </div>
                      <IceAndSugar
                        selectedValue={ice}
                        onSelected={this.onChangeIceAndSugar}
                        name="ice"
                        disabled={false}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md={6}>
                    <FormGroup className="mb-4">
                      <div className="d-flex mb-2">
                        <Input
                          className="custom-input-underline w-50 pad-2px"
                          type="text"
                          name="sugarTitle"
                          value={sugarTitle}
                          placeholder="Độ ngọt"
                          onChange={this.handleTitleChange}
                        />
                      </div>
                      <IceAndSugar
                        selectedValue={sugar}
                        onSelected={this.onChangeIceAndSugar}
                        name="sugar"
                        disabled={false}
                      />
                    </FormGroup>
                  </Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : (
            <div>
              <Row>
                {/* Size - Available for Fashion, Retail, Cosmetics */}
                <Colxx md={12}>
                  <FormGroup>
                    <Label>
                      {isRetail ? (
                        <Input
                          bsSize="sm"
                          className="font-weight-bold p-0 border-0"
                          value={this.state.sizeTitle} // Although stored as sizeTitle, mapped to unit in retail
                          // Note: sizeTitle comes from F&B logic, but we reuse it here or create a new one?
                          // Actually 'sizeTitle' in state is for F&B.
                          // We might need to handle 'sizeTitle' update if isRetail.
                          // Ensure 'sizeTitle' is initialized correctly.
                          // Let's assume we reuse 'sizeTitle' state for convenience or add specific 'sizeTitle' handling?
                          // Wait, 'sizeTitle' is line 29.
                          onChange={(e) =>
                            this.setState({ sizeTitle: e.target.value })
                          }
                          // Or use handleTitleChange?
                          name="sizeTitle"
                          placeholder="Tên thuộc tính..."
                        />
                      ) : isCosmetics ? (
                        "Dung tích (50ml, 300ml...)"
                      ) : (
                        "Size / Kích thước"
                      )}
                    </Label>
                    <Creatable
                      isMulti
                      name="sizeOptions"
                      value={this.state.sizeOptions}
                      onChange={(val) =>
                        this.handleCreatableChange(val, { name: "sizeOptions" })
                      }
                      options={this.props.allSizeOptions}
                      placeholder="Nhập và nhấn Enter để tạo..."
                      formatCreateLabel={(inputValue) => `Tạo "${inputValue}"`}
                      className="react-select"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      createOptionPosition="first"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </FormGroup>
                </Colxx>

                {/* Color - Available for Fashion, Cosmetics, Retail */}
                <Colxx md={12}>
                  <FormGroup>
                    <Label>
                      {isRetail ? (
                        <Input
                          bsSize="sm"
                          className="font-weight-bold p-0 border-0"
                          value={this.state.colorTitle}
                          onChange={(e) => this.handleTitleChange(e)}
                          name="colorTitle"
                          placeholder="Tên thuộc tính..."
                        />
                      ) : isCosmetics ? (
                        "Màu sắc / Tone màu"
                      ) : (
                        "Màu sắc"
                      )}
                    </Label>
                    <Creatable
                      isMulti
                      name="colorOptions"
                      value={this.state.colorOptions}
                      onChange={(val) =>
                        this.handleCreatableChange(val, {
                          name: "colorOptions",
                        })
                      }
                      options={this.props.allColorOptions}
                      placeholder="Nhập và nhấn Enter để tạo..."
                      formatCreateLabel={(inputValue) => `Tạo "${inputValue}"`}
                      className="react-select"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      createOptionPosition="first"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </FormGroup>
                </Colxx>

                {/* Material - Available for Fashion / Retail */}
                {!isCafe && !isCosmetics && (
                  <Colxx md={12}>
                    <FormGroup>
                      <Label>
                        {isRetail ? (
                          <Input
                            bsSize="sm"
                            className="font-weight-bold p-0 border-0"
                            value={this.state.materialTitle}
                            onChange={(e) => this.handleTitleChange(e)}
                            name="materialTitle"
                            placeholder="Tên thuộc tính..."
                          />
                        ) : (
                          "Chất liệu"
                        )}
                      </Label>
                      <Creatable
                        isMulti
                        name="materialOptions"
                        value={this.state.materialOptions}
                        onChange={(val) =>
                          this.handleCreatableChange(val, {
                            name: "materialOptions",
                          })
                        }
                        options={this.props.allMaterialOptions}
                        placeholder="Nhập và nhấn Enter để tạo..."
                        formatCreateLabel={(inputValue) =>
                          `Tạo "${inputValue}"`
                        }
                        className="react-select"
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        createOptionPosition="first"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </FormGroup>
                  </Colxx>
                )}
              </Row>

              {/* Variant Generation UI */}
              <div className="mb-3 align-items-center">
                <Button
                  size="sm"
                  outline
                  color="info"
                  className="mr-2"
                  onClick={this.handleGenerateVariants}
                >
                  Tạo biến thể tự động
                </Button>
              </div>

              {generatedVariants.length > 0 && (
                <>
                  <Separator className="mb-3" />
                  <h6 className="mb-3">
                    Danh sách biến thể đã tạo ({generatedVariants.length})
                  </h6>
                  {/* Master Settings Card */}

                  <Card className="mb-4">
                    <CardBody className="p-3">
                      <h6 className="mb-4">Áp dụng hàng loạt</h6>

                      <div className="d-flex overflow-hidden mb-2 pt-2">
                        <Colxx
                          xs={6}
                          className="has-float-label p-0 font-weight-bold"
                        >
                          SKU: {this.state.baseSku}
                        </Colxx>
                        <Colxx xs={6} className="pr-2 has-float-label p-0">
                          <FormGroup className="mb-0">
                            <Label className="text-muted text-small">
                              Số lượng nhập chung
                            </Label>
                            <PriceInput
                              value={masterVariantSettings.quantity}
                              name="quantity"
                              onChange={(val, name) =>
                                this.handleMasterSettingsChange(val, name)
                              }
                            />
                          </FormGroup>
                        </Colxx>
                      </div>

                      <div className="d-flex overflow-hidden mb-2 pt-2">
                        <Colxx xs={3} className="pr-2 has-float-label p-0">
                          <FormGroup className="mb-0">
                            <Label className="text-muted text-small">
                              Giá bán chung
                            </Label>
                            <PriceInput
                              value={masterVariantSettings.price}
                              name="price"
                              onChange={(val, name) =>
                                this.handleMasterSettingsChange(val, name)
                              }
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx xs={3} className="pr-2 has-float-label p-0">
                          <FormGroup className="mb-0">
                            <Label className="text-muted text-small">
                              Giá sỉ chung
                            </Label>
                            <PriceInput
                              value={masterVariantSettings.price_wholesale}
                              name="price_wholesale"
                              onChange={(val, name) =>
                                this.handleMasterSettingsChange(val, name)
                              }
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx xs={3} className="pr-2 has-float-label p-0">
                          <FormGroup className="mb-0">
                            <Label className="text-muted text-small">
                              Giá vốn chung
                            </Label>
                            <PriceInput
                              value={masterVariantSettings.cost_price}
                              name="cost_price"
                              onChange={(val, name) =>
                                this.handleMasterSettingsChange(val, name)
                              }
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx xs={3} className="has-float-label p-0">
                          <FormGroup className="mb-0">
                            <Label className="text-muted text-small">
                              Giá KM chung
                            </Label>
                            <PriceInput
                              value={masterVariantSettings.promo_price}
                              name="promo_price"
                              onChange={(val, name) =>
                                this.handleMasterSettingsChange(val, name)
                              }
                            />
                          </FormGroup>
                        </Colxx>
                      </div>

                      {Number(masterVariantSettings.promo_price) > 0 ? (
                        <div className="d-flex mb-2 pt-2">
                          <Colxx xs={6} className="pr-2 has-float-label p-0">
                            <FormGroup className="mb-0">
                              <Label className="text-muted text-small">
                                Ngày bắt đầu
                              </Label>
                              <DatePicker
                                className="form-control"
                                selected={masterVariantSettings.date_start}
                                onChange={(d) =>
                                  this.handleMasterSettingsChange(
                                    d,
                                    "date_start",
                                  )
                                }
                                dateFormat="YYYY-MM-DD"
                                placeholderText="YYYY-MM-DD"
                              />
                            </FormGroup>
                          </Colxx>
                          <Colxx xs={6} className="has-float-label p-0">
                            <FormGroup className="mb-0">
                              <Label className="text-muted text-small">
                                Ngày kết thúc
                              </Label>
                              <DatePicker
                                className="form-control"
                                selected={masterVariantSettings.date_end}
                                onChange={(d) =>
                                  this.handleMasterSettingsChange(d, "date_end")
                                }
                                dateFormat="YYYY-MM-DD"
                                placeholderText="YYYY-MM-DD"
                                popperPlacement="bottom-end"
                              />
                            </FormGroup>
                          </Colxx>
                        </div>
                      ) : null}

                      <div className="d-flex justify-content-end mt-3">
                        <Button
                          color="primary"
                          size="sm"
                          onClick={this.applyMasterSettingsToAll}
                        >
                          <i className="simple-icon-check mr-2" />
                          Áp dụng cho tất cả
                        </Button>
                      </div>
                    </CardBody>
                  </Card>

                  {/* Variants List */}
                  {generatedVariants.map((variant) => (
                    <Card key={variant.id} className="mb-2">
                      <CardBody className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 style={{ fontWeight: 600 }}>{variant.name}</h6>
                          <Button
                            close
                            onClick={() => this.handleDeleteVariant(variant.id)}
                          />
                        </div>

                        {/* SKU Row */}
                        <div className="mb-2 font-weight-bold">
                          SKU: {variant.sku}
                        </div>

                        {/* Quantity & Exchange Rate Row (Retail) */}
                        {(() => {
                          // Determine if this variant is the "base unit" variant
                          const baseUnit = this.props.baseUnit || "";
                          const variantSizeValue =
                            variant.size?.value || variant.size?.label || "";
                          const isBaseUnitVariant =
                            baseUnit &&
                            variantSizeValue &&
                            variantSizeValue.toLowerCase() ===
                              baseUnit.toLowerCase();

                          if (isRetail) {
                            if (isBaseUnitVariant) {
                              // Base Unit Variant: No quantity/exchange input needed
                              // (main form has stock_quantity and stock_cost_price)
                              return (
                                <Row className="mb-2">
                                  <Colxx xs={12}>
                                    <small className="text-muted">
                                      <i className="simple-icon-info mr-1" />
                                      Đơn vị gốc - Số lượng và Giá vốn được nhập
                                      ở form chính
                                    </small>
                                  </Colxx>
                                </Row>
                              );
                            } else {
                              // Derived Unit Variant: Show Quy đổi only (no quantity input)
                              return (
                                <Row className="mb-2">
                                  <Colxx xs={12} className="has-float-label">
                                    <FormGroup className="mb-0">
                                      <Label className="text-muted text-small">
                                        Quy đổi số lượng (1{" "}
                                        {variantSizeValue || "ĐVT này"} = ?{" "}
                                        {baseUnit || "ĐVT chuẩn"})
                                      </Label>
                                      <PriceInput
                                        bsSize="sm"
                                        placeholder="1"
                                        value={variant.exchange_value}
                                        onChange={(val) =>
                                          this.onChangeVariant(
                                            variant.id,
                                            "exchange_value",
                                            val,
                                          )
                                        }
                                      />
                                    </FormGroup>
                                  </Colxx>
                                </Row>
                              );
                            }
                          } else {
                            // Non-Retail: Show Số lượng nhập only
                            return (
                              <Row className="mb-2">
                                <Colxx xs={12} className="has-float-label">
                                  <FormGroup className="mb-0">
                                    <Label className="text-muted text-small">
                                      Số lượng nhập vào{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.quantity}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "quantity",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                              </Row>
                            );
                          }
                        })()}

                        {/* Price Row */}
                        {(() => {
                          // Check if this is base unit variant (for retail)
                          const baseUnit = this.props.baseUnit || "";
                          const variantSizeValue =
                            variant.size?.value || variant.size?.label || "";
                          const isBaseUnitVariant =
                            isRetail &&
                            baseUnit &&
                            variantSizeValue &&
                            variantSizeValue.toLowerCase() ===
                              baseUnit.toLowerCase();

                          if (isBaseUnitVariant) {
                            // Base Unit: Only show Giá bán, Giá sỉ and Giá KM (no Giá vốn)
                            return (
                              <Row>
                                <Colxx xs={4} className="pr-1 has-float-label">
                                  <FormGroup className="mb-1">
                                    <Label className="text-muted text-small">
                                      Giá bán{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.price}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "price",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx xs={4} className="px-1 has-float-label">
                                  <FormGroup className="mb-1">
                                    <Label className="text-muted text-small">
                                      Giá sỉ
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.price_wholesale}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "price_wholesale",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx xs={4} className="pl-1 has-float-label">
                                  <FormGroup className="mb-1">
                                    <Label className="text-muted text-small">
                                      Giá KM
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.promo_price}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "promo_price",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                              </Row>
                            );
                          } else {
                            // Regular variant: Show all 4 price fields
                            return (
                              <Row>
                                <Colxx xs={3} className="pr-1 has-float-label">
                                  <FormGroup className="mb-1">
                                    <Label className="text-muted text-small">
                                      Giá bán{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.price}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "price",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx xs={3} className="px-1 has-float-label">
                                  <FormGroup className="mb-1">
                                    <Label className="text-muted text-small">
                                      Giá sỉ
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.price_wholesale}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "price_wholesale",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx xs={3} className="px-1 has-float-label">
                                  <FormGroup className="mb-1">
                                    <Label className="text-muted text-small">
                                      Giá vốn{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.cost_price}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "cost_price",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx xs={3} className="pl-1 has-float-label">
                                  <FormGroup className="mb-1">
                                    <Label className="text-muted text-small">
                                      Giá KM
                                    </Label>
                                    <PriceInput
                                      bsSize="sm"
                                      value={variant.promo_price}
                                      onChange={(val) =>
                                        this.onChangeVariant(
                                          variant.id,
                                          "promo_price",
                                          val,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                              </Row>
                            );
                          }
                        })()}
                      </CardBody>
                    </Card>
                  ))}
                </>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Hủy
          </Button>
          <Button color="primary" onClick={this.handleSave}>
            Lưu biến thể
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ProductVariantConfigModal;
